"use strict";
// import { apiPost } from "../api";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign_up = void 0;
var api_1 = require("../../api");
var sign_up = function (request) {
    return (0, api_1.apiPost)({
        endpoint: "v3/user/sign_up",
        data: request,
    });
};
exports.sign_up = sign_up;
